import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from '@modules/authentication';
import {defaultRoute} from '../settings/mathia';

@Injectable({
    providedIn: 'root'
})
export class ChangeDefaultRouteGuard implements CanActivate {
    constructor(private authService: AuthenticationService,
                private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const canActivate = !(this.authService.isLearner() && this.authService.isGAR());
        if (canActivate === false) {
            this.router.navigate(['followed', 'tab']);

        } else {
            this.router.navigate([defaultRoute]);
        }
        return true;
    }

}
